
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/edu-solution",
      function () {
        return require("private-next-pages/edu-solution.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/edu-solution"])
      });
    }
  